import React from "react";
import { ICellRendererParams } from "@ag-grid-community/core";

import { getFormattedDateRange } from "../../../../helpers/format";
import { PickupRequestListItem } from "../../../../types";

import TwoLineGridCell from "../TwoLineGridCell";

interface Props extends ICellRendererParams {
  data: PickupRequestListItem;
}

const DateRangeGridCell = (props: Props) => {
  const { pickupDateFrom, pickupDateTo } = props.data;

  return (
    <TwoLineGridCell
      firstLineData={getFormattedDateRange(
        pickupDateFrom ?? "",
        pickupDateTo ?? ""
      )}
    />
  );
};

export default DateRangeGridCell;
